import {AffiliateBaseView} from "../../AffiliateModel/view/AffiliateBaseView";
import {ExpertRolePriceSystemEnum} from "../../ExpertRoleModel/constants/ExpertRolePriceSystemEnum";
import {BankStatusEnum} from "../../BankModel/enum/BankStatusEnum";
import {AiFraudVerdictType} from "../../ExpertRoleModel/constants/AiFraudVerdictEnum";

export class MemberSearchResultView {
    id: number;
    companyName: string;
    businessTypes: ExpertBusinessTypeCountView[];
    firstName: string;
    lastName: string;
    email: string;
    // loginId: string;
    telNumber: string;
    userGroupName: string;
    userGroupId: number;
    expertRoleCapping: ExpertRoleView;
    accountManager: string;
    vendor: string;
    affiliate: AffiliateBaseView[];
    status: number;
    bankModels: BankView[];
    aiFraudVerdict: AiFraudVerdictType | null;

    constructor(data?: any) {
        this.id = data?.id ?? -1;
        this.companyName = data?.companyName ?? "";
        this.businessTypes = data?.businessTypes?.map((b: any) => new ExpertBusinessTypeCountView(b)) ?? [];
        this.firstName = data?.firstName ?? "";
        this.lastName = data?.lastName ?? "";
        this.email = data?.email ?? "";
        // this.loginId = data?.loginId ?? "";
        this.telNumber = data?.telNumber ?? "";
        this.userGroupName = data?.userGroupName ?? "";
        this.userGroupId = data?.userGroupId ?? -1;
        this.expertRoleCapping = new ExpertRoleView(data?.expertRoleCapping);
        this.accountManager = data?.accountManager ?? "";
        this.vendor = data?.vendor ?? "";
        this.affiliate = data?.affiliate?.map((a: any) => new AffiliateBaseView(a)) ?? [];
        this.status = data?.status ?? "";
        this.bankModels = data?.bankModels?.map((b: any) => new BankView(b)) ?? [];
        this.aiFraudVerdict = data?.aiFraudVerdict ?? null;
    }
}


class ExpertBusinessTypeCountView {
    countBusinessTypeName: string;
    businessTypeName: string;
    zeroCappingCount: number;

    constructor(data?: any) {
        this.businessTypeName = data?.businessTypeName ?? "";
        this.countBusinessTypeName = data?.countBusinessTypeName ?? "";
        this.zeroCappingCount = data?.zeroCappingCount ?? 0;
    }
}

class ExpertRoleView {
    id: number;
    dailyMaxLeads: number;
    monthlyMaxLeads: number;
    endDateHolidaysCapping: Date;
    startDateHolidaysCapping: Date;
    priceSystem: ExpertRolePriceSystemEnum;

    constructor(data?: any) {
        this.id = data?.id ?? -1;
        this.dailyMaxLeads = data?.dailyMaxLeads ?? -1;
        this.monthlyMaxLeads = data?.monthlyMaxLeads ?? -1;
        this.endDateHolidaysCapping = data?.endDateHolidaysCapping ?? null;
        this.startDateHolidaysCapping = data?.startDateHolidaysCapping ?? null;
        this.priceSystem = data?.priceSystem ?? null;
    }
}


class BankView {
    id: number;
    status: BankStatusEnum;


    constructor(data?: any) {
        this.id = data?.id ?? -1;
        this.status = data?.status ?? 0;
    }
}